import { render } from "./TextbookDownload.vue?vue&type=template&id=dbcece1c&scoped=true"
import script from "./TextbookDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./TextbookDownload.vue?vue&type=script&setup=true&lang=js"

import "./TextbookDownload.vue?vue&type=style&index=0&id=dbcece1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcece1c"],['__file',"src/components/course/TextbookDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbcece1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbcece1c', __exports__)) {
    api.reload('dbcece1c', __exports__)
  }
  
  module.hot.accept("./TextbookDownload.vue?vue&type=template&id=dbcece1c&scoped=true", () => {
    api.rerender('dbcece1c', render)
  })

}


export default __exports__